<template>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        <br />
        {{ userStore.user.ssn }}
        <br />
        <br />
        {{ creditBureau.address_name }}
        <br />
        {{ creditBureau.street_address }}
        <br />
        {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
        <br />
        <br />
        Date: {{ date }}
    </p>
    <div class="page">
        <template v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id, 'public-record')">
            <p class="letter-content">
                I have recently been informed that there is negative information reported by 
                <strong>"{{ creditor.furnisher_name }}"</strong> 
                in the file you maintain under my Social Security number. Upon ordering a copy of my credit report, I see an entry from this court listing 
                <strong>"Bankruptcy: {{ creditor.type }}"</strong> 
                with 
                <strong>Reference#: {{ creditor.reference_number }}</strong> 
                filed in 
                <strong>{{ creditor.date_filed_reported }}</strong>.
            </p>
            <p class="letter-content">
                I am unaware of 
                <strong>"{{ creditor.furnisher_name }}"</strong> 
                with 
                <strong>Reference#: {{ creditor.reference_number }}</strong> 
                filed in 
                <strong>{{ creditor.date_filed_reported }}</strong>.
            </p>
        </template>
        <p class="letter-content">
            Please validate this information with the court and provide me with copies of any documentation associated with this account, bearing my signature. In the absence of any such documentation bearing my signature, I formally request that this information be immediately deleted from the credit file you maintain under my Social Security number.
        </p>
        <p>
            Best Regards,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>